var _g, _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWorm(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15718_8284)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    fill: "#2656EF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7373 12.5195C15.79 12.4091 14.8447 12.7392 14.1728 13.415L11.6982 15.8896H11.6972C11.5165 16.082 11.2783 16.2089 11.0175 16.2499C10.541 16.3115 10.079 16.0644 9.86613 15.6337C9.65421 15.2031 9.73918 14.6855 10.0771 14.3447L15.0771 9.34469C16.3007 8.12887 16.3066 6.15044 15.0898 4.92769C13.8739 3.70407 11.8955 3.69819 10.6728 4.915L7.42276 8.165C7.27628 8.31637 7.09074 8.42477 6.88761 8.4775C6.50481 8.57223 6.10051 8.45992 5.82121 8.18062C5.54289 7.9023 5.43059 7.498 5.52531 7.1152C5.57805 6.9111 5.68547 6.72555 5.83781 6.58005L6.70011 5.71775C6.99211 5.43357 7.08291 4.99997 6.9296 4.62302C6.77531 4.2451 6.40813 3.999 5.9999 3.99997C5.73428 3.99997 5.48038 4.10544 5.29288 4.29295L4.47745 5.10837V5.1074C3.92178 5.64352 3.5751 6.35935 3.4999 7.1279C3.39639 8.43062 4.1161 9.66015 5.30263 10.2079C6.48915 10.7567 7.89138 10.5077 8.81738 9.58485L12.0419 6.36035H12.0429C12.2255 6.16601 12.4686 6.03905 12.7323 6C13.2089 5.93847 13.6708 6.18554 13.8837 6.6162C14.0956 7.04687 14.0106 7.56445 13.6727 7.90525L8.67274 12.9052C7.44912 14.1211 7.44324 16.0995 8.66005 17.3222C9.87587 18.5459 11.8543 18.5517 13.077 17.3349L15.577 14.8349C15.7235 14.6836 15.9091 14.5752 16.1122 14.5224C16.495 14.4277 16.8993 14.54 17.1786 14.8193C17.4569 15.0976 17.5692 15.5019 17.4745 15.8847C17.4218 16.0888 17.3143 16.2744 17.162 16.4199L16.2997 17.2822C16.0077 17.5664 15.9169 18 16.0702 18.3769C16.2245 18.7548 16.5917 19.0009 16.9999 19C17.2655 19 17.5194 18.8945 17.7069 18.707L18.5868 17.8271H18.5878C19.4325 16.9804 19.7196 15.7246 19.3261 14.5936C18.9315 13.4637 17.9266 12.6582 16.7373 12.5195Z",
    fill: "white"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 23,
    rx: 3.5,
    stroke: "black",
    strokeOpacity: 0.06
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15718_8284"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorm);
export default __webpack_public_path__ + "static/media/worm.afeb090841da07c56bacae64d1d6db11.svg";
export { ForwardRef as ReactComponent };